import { FormikHelpers } from 'formik';
import { FORM_MODE } from 'b2b-apps/shop/common/utils/form/form';

type UseFormModeReturnType<T> = {
  isCreateMode: boolean;
  isUpdateMode: boolean;
  onSubmit: (values: T, actions?: FormikHelpers<T>) => void;
};

const useFormMode = <T extends Record<string, any>>(
  formMode: FORM_MODE,
  onCreateSubmit: (values: T, actions?: FormikHelpers<T>) => void,
  onUpdateSubmit: (values: T, actions?: FormikHelpers<T>) => void,
): UseFormModeReturnType<T> => {
  const isCreateMode = formMode === FORM_MODE.create;

  return {
    isCreateMode,
    isUpdateMode: !isCreateMode,
    onSubmit: isCreateMode ? onCreateSubmit : onUpdateSubmit,
  };
};

export type { UseFormModeReturnType };
export { useFormMode };
